import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { ProcessSection } from '../components/ProcessSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { PurchaseToast } from '../components/PurchaseToast';
interface SalesPageProps {
  showPurchaseToast?: boolean;
}
export function SalesPage({
  showPurchaseToast = false
}: SalesPageProps) {
  return <main className="min-h-screen bg-stone-50 font-sans selection:bg-emerald-200 selection:text-emerald-900" data-id="element-432">
      <Hero data-id="element-433" />
      <ProblemSection data-id="element-434" />
      <SolutionSection data-id="element-435" />
      <IncludesSection data-id="element-436" />
      <ProcessSection data-id="element-437" />
      <TestimonialsSection data-id="element-438" />
      <CTASection enableExitIntent={showPurchaseToast} data-id="element-439" />
      <FAQSection data-id="element-440" />
      <Footer data-id="element-441" />
      {showPurchaseToast && <PurchaseToast data-id="element-442" />}
    </main>;
}